import { HomeQueries } from '@/graphql/queries/home.queries'
import { HomeTimeline } from '@/types/Homes'

import { useGraphql } from '../useGraphql'

export function useTimeline({ id }: { id: number }) {
  const { data, ...restOfQuery } = useGraphql<{ home: HomeTimeline }>(
    HomeQueries.QUERY_KEYS.getHomeTimeline,
    HomeQueries.getHomeTimeline(),
    { id: id },
    {
      enabled: !!id,
    },
  )

  return { data, ...restOfQuery }
}
